// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"937":"75891c54","1716":"3ad3631a","2506":"5547f192","9801":"86a6bf80"}[chunkId] + ".chunk.css";
};